module.exports = __webpack_public_path__ + "img/male.00e05c74.svg";